"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const notInitialized_1 = require("../notInitialized");
class DropdownService {
    constructor() {
        this.currentDropdown = null;
        this.listenerCallback = notInitialized_1.notInitialized;
        this.isOpen = false;
        this.previousContainer = null;
    }
    openDropdown(container, dropdownElement, onClose) {
        this.closeCurrentDropdown();
        onClose();
        if (this.isOpen && container === this.previousContainer) {
            this.isOpen = false;
            return null;
        }
        container.append(dropdownElement);
        this.listenerCallback = () => {
            this.closeCurrentDropdown();
            onClose();
            this.isOpen = false;
        };
        window.addEventListener('click', this.listenerCallback);
        this.currentDropdown = dropdownElement;
        this.previousContainer = container;
        this.isOpen = true;
        return this.currentDropdown;
    }
    closeCurrentDropdown() {
        if (this.currentDropdown) {
            this.currentDropdown.remove();
            this.currentDropdown = null;
        }
        window.removeEventListener('click', this.listenerCallback);
    }
}
exports.default = DropdownService;
